<template>
  <div class="search-container">
    <div class="search-header" v-if="result">
      <div class="container">
        <v-row>
          <v-col cols="12" lg="8">
            <div class="search-title">
              Showing <span class="search-count" >{{result.length}}</span> results for
              <span class="search-result" v-if="$route.query.sortName">{{ this.$route.query.sortName }}</span>
              <span class="search-result" v-else>{{ this.$route.query.search }}</span>
              <v-tooltip right v-if="this.$route.query.sortName">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    color="error"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="cancelSorting()"
                    class="ml-2"
                  >
                   <v-icon>mdi-close</v-icon>
                  </v-chip>
                </template>
                <span>Clear Sorting</span>
              </v-tooltip>
            </div>
          </v-col>
          <v-col cols="12" lg="4" class="d-flex justify-end">
            <div class="search-filter d-flex align-center">
              Sort By
              <div class="sort-filter">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn class="categories-btn" text v-on="on"
                      >Choose
                      <v-icon right dark> mdi-chevron-down </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(sort, i) in sortBy" :key="i" @click="sortdata(sort.text)">
                      <v-list-item-title class="dropdown_menu">{{
                        sort.text
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>

    <section class="course-list-wrapper">
      <v-container>
        <v-row v-if="result">
          <v-col cols="12" sm="6" md="6" lg="4" v-for="(search, i) in result" :key="i">
              <CourseCard
                :course="search"
              ></CourseCard>
          </v-col>
        </v-row>

        <div class="course-list__pagination" v-if="result">
          <div class="text-right">
            <div class="text-center">
                <v-pagination
                v-model="dataOption.page"
                :length="dataOption.length"
                :total-visible="7"
                ></v-pagination>
            </div>
          </div>
        </div>
      </v-container>
    </section>

    <KeepLearning v-if="result"></KeepLearning>
  </div>
</template>

<script>
import CourseCard from "@/components/Courses/CourseCard.vue";
import CoursePagination from "@/components/Courses/CoursePagination.vue";
import KeepLearning from "@/components/KeepLearning/KeepLearning.vue";
export default {
  name: "CourseList",
  data() {
    return {
      sortBy: [
        {text: "Best"},
        {text: "Feature"},
      ],
      courses: [],
      query: '',
      result: '',
      sortText: '',
      reqestData: {
        page: 1,
        count: '',
      },
      sortData: {
        is_bestselling: false,
        is_feature: false,
      },
      dataOption: {
        page: 1,
        page_size: 10,
        length: null,
        is_best: false,
        is_feature: false,
      }
    };
  },
  components: {
      CourseCard,
      CoursePagination,
      KeepLearning
  },
  created () {
     this.$bus.on('search-result', (result)=>{
       this.result = result;

        if(result.length === 0) {
          this.$router.push('/page-not-found')
        }
     });
  },
  methods: {
    goToSingleCourse() {
      this.$router.push("/single-course");
    },
    async getCourseName(val) {
      this.query = val;
      let payload = {page:this.dataOption.page, page_size:this.dataOption.page_size, search:this.query}
      await this.$api.getWithPayload(`course/paginated/`, payload).then((res) => {
        this.result = res.results;
        this.reqestData.count = res.count;
        if(res.count > this.dataOption.page_size) {
          this.dataOption.length = res.count / this.dataOption.page_size;
          this.dataOption.length = Math.trunc(this.dataOption.length)
        }
        else if(res.count < this.dataOption.page_size) {
          this.dataOption.length = 1;
        }
        else if(res.count === this.dataOption.page_size) {
          this.dataOption.length = 1;
        }
      })
    },
    async pagination(val) {
      this.$bus.emit('loading-toggle');
      let payload = {page:this.dataOption.page, page_size:this.dataOption.page_size, search:this.query}
        await this.$api.getWithPayload(`course/paginated/`, payload).then((res) => {
          this.result = res.results;
          this.reqestData.count = res.count;
          if(res.count > this.dataOption.page_size) {
            this.dataOption.length = this.reqestData.count / this.dataOption.page_size;
            this.dataOption.length = parseInt(this.dataOption.length)
          }
          else  {
            this.dataOption.length = 1;
          }
        })
        this.$bus.emit('loading-toggle');
    },
    async sortdata(val) {
      this.sortText = val
      if(this.sortText === 'Best') {
        this.sortData.is_bestselling = true
        let payload = {page:this.dataOption.page, page_size:this.dataOption.page_size, search:this.query, is_bestselling:this.sortData.is_bestselling}
        await this.$api.getWithPayload(`course/paginated/?`, payload).then(res => {
          this.categorycourses = res.results
        })
        this.$router.push(`/search/?search=${this.$route.query.search}&sortName=${this.sortText}`);
      }
      else if(this.sortText === 'Feature') {
        this.sortData.is_feature = true
        let payload = {page:this.dataOption.page, page_size:this.dataOption.page_size, search:this.query, is_feature:this.sortData.is_feature}
        await this.$api.getWithPayload(`course/paginated/?`, payload).then(res => {
          this.categorycourses = res.results
        })
        this.$router.push(`/search/?search=${this.$route.query.search}&sortName=${this.sortText}`);
      }
    },
    async getCategoryId() {
      let result = this.$route.query.search;
      await this.$api.get(`course/paginated/?&category=${result}`).then((res) => {
        this.result = res.results;
      })
    },
    async cancelSorting() {
      this.$bus.emit('loading-toggle')
      let payload = {
        category: this.$route.query.category,
      }
      await this.$api.getWithPayload('/course/paginated/',payload).then(res => {
        this.categorycourses = res.results
        this.$router.push(`/search/?search=${this.$route.query.search}`)
        this.$bus.emit('loading-toggle')
      })
    }
  },
  
  mounted () { 
    // console.log(this.$route.query)
    //  this.$api.getWithPayload('/course/paginated/',this.$route.query).then(res => {
    //     this.result= res.results;
    //   }) 
    this.getCourseName(this.$route.query.search)
    this.pagination(this.dataOption.page)

  },

  watch: {
    query: {
      handler(val) {
        if(val) {
          this.getCourseName(val);
        }
      },
      deep: true
    },
    'dataOption.page': {
      handler(val) {
        this.pagination(val)
      }
    }
  },
};
</script>

<style lang="scss">
/*Search Page*/
.v-list-item {
  min-height: auto;
  padding: 9px 15px;

  & + * {
    border-top: 1px solid rgba(#0ea1df, 0.1);
  }
}

.v-list-item__title {
  font-size: 14px;
}
.search-container {
  padding: 2.5rem 0 0;
}
.search-title {
  font-weight: 400;
  font-family: var(--font-poppins);
  font-size: 24px;
  line-height: 1.5;
  .search-count {
    font-weight: 600;
  }
  .search-result {
    font-family: var(--font-lora);
    color: var(--color-red);
    font-weight: 700;
  }
}

.search-filter {
  font-size: 14px;
  font-family: var(--font-poppins);
  font-weight: 400;
  .sort-filter {
    margin-left: 18px;
    font-weight: 500;
  }
}

/*Media Object Default CSS Rule*/
img,
iframe,
video {
  max-width: 100%;
}

/* Pagination CSS Rule */
.pagination {
  list-style: none;
  font-size: 18px;
  font-family: var(--font-poppins);

  li + li {
    margin-left: 8px;
  }
}
</style>